import React from 'react'
import { Route, Routes } from 'react-router-dom'
import { ROUTES } from './constants/routes'
import BaseLayout from './layouts/BaseLayout'
import ExamplePage from './pages/example/ExamplePage'
import NotFoundPage from './pages/notFound/NotFoundPage'

// All routes nest under BaseLayout (app shell + <Outlet />). A real app adds further nested
// layouts/guards here the same way (e.g. an AuthGuard wrapping a protected route group) — see
// Resactly's RouterApp.tsx for that pattern at full scale.
const RouterApp: React.FC = () => {
  return (
    <Routes>
      <Route element={<BaseLayout />}>
        <Route path={ROUTES.HOME} element={<ExamplePage />} />
        <Route path={ROUTES.EXAMPLE} element={<ExamplePage />} />
        <Route path={ROUTES.NOTFOUND} element={<NotFoundPage />} />
        <Route path="*" element={<NotFoundPage />} />
      </Route>
    </Routes>
  )
}

export default RouterApp
